import { supabaseClient } from "@/lib/database/supabase";
import useAuthStore from "@/stores/useAuthStore";
import { CrewMembershipWithCrew } from "@shared/lib/database/query.types";
import { defineStore, storeToRefs } from "pinia";
import { computed, ref, watch } from "vue";

export default defineStore("CurrentPlayerStore", () => {
  const authStore = useAuthStore();
  const {
    currentPlayer,
  } = storeToRefs(authStore);
  const {
    waitForPlayer,
  } = authStore;

  const crewMemberships = ref<Array<CrewMembershipWithCrew>>([]);

  const crews = computed(() => {
    return crewMemberships.value.map(({
      crew,
    }) => crew);
  });

  const commissionerCrews = computed(() => {
    return crewMemberships.value.filter(({
      role,
    }) => role === "commissioner").map(({
      crew,
    }) => crew);
  });

  watch(currentPlayer, () => {
    if (currentPlayer.value?.crew_memberships) {
      updateCrewMemberships(currentPlayer.value.crew_memberships);
    }
  }, {
    immediate: true,
  });

  async function fetchCrewMemberships () {
    if (!currentPlayer.value) await waitForPlayer();
    if (!currentPlayer.value) throw new Error("Player isn’t loaded");

    const {
      data: _crewMemberships,
    } = await supabaseClient
      .from("player_crews")
      .select("*, crew:crews!inner(*)")
      .match({
        player_id: currentPlayer.value.id,
      })
      .order("crew(name)")
      .throwOnError();

    updateCrewMemberships(_crewMemberships || []);
  }

  function updateCrewMemberships (_crewMemberships: Array<CrewMembershipWithCrew>) {
    crewMemberships.value = _crewMemberships;
  }

  return {
    crewMemberships,
    crews,
    commissionerCrews,
    fetchCrewMemberships,
  };
});
